import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface SearchResult {
  result_type: string;
  id: string;
  title: string;
  subtitle: string | null;
  parent_id: string | null;
  updated_at: string;
}

export const useGlobalSearch = () => {
  const [query, setQuery] = useState('');
  const { user } = useAuth();
  const trimmed = query.trim();

  const { data: results = [], isLoading } = useQuery({
    queryKey: ['global-search', trimmed],
    enabled: !!user && trimmed.length >= 2,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('global_search', {
        q: trimmed,
        max_per_type: 5,
      });
      if (error) throw error;
      return (data as SearchResult[]) ?? [];
    },
    staleTime: 30_000,
  });

  return { query, setQuery, results, isLoading };
};
